import { useSelector } from 'react-redux';
import { keepPreviousData } from '@tanstack/react-query';

import { AppID, Environment } from '@playq/octopus-common';
import { GenericFailure } from '@playq/services-shared';
import { TeamIdWithTemplateId, TeamLookup } from '@playq/services-teams';

import { IUseQueryOptionsExtended, useEitherQuery } from '/api/service-hooks';
import { services2 } from '/api/services2';
import { appToolkit } from '/store';

export const defaultTeamName = 'Team';
const keys: unknown[] = ['teams', 'service', 'support', 'getTeam'];
const emptyArray: [] = [];

export const useGetTeam = (
  teamId: TeamIdWithTemplateId,
  env: Environment,
  options?: IUseQueryOptionsExtended<TeamLookup | undefined, GenericFailure | Error>
) => {
  const appID: AppID | undefined = useSelector(appToolkit.selectors.appID);

  const res = useEitherQuery(
    keys.concat(appID, teamId, env),
    () => {
      if (appID) {
        return services2.teamsLookupService.getTeam(appID, teamId, env);
      }
    },
    {
      placeholderData: keepPreviousData,
      ...options,
    }
  );

  return {
    ...res,
    vault: res.data?.vault,
    team: res.data?.team,
    name: res.data?.team.name ?? defaultTeamName,
    members: res.data?.members || emptyArray,
  };
};
